// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { CSVLink } from 'react-csv';
import { CommonPropTypes } from 'react-csv/components/CommonPropTypes';

export type CustomCSVLinkProps = CommonPropTypes & {
  withBOM?: boolean;
  className?: string;
  children?: React.ReactNode;
};

const CustomCSVLink = React.forwardRef(
  (
    { withBOM = true, className, children, ...csvProps }: CustomCSVLinkProps,
    ref: any
  ) => {
    return (
      <CSVLink className={className} uFEFF={withBOM} {...csvProps} ref={ref}>
        {children}
      </CSVLink>
    );
  }
);

export default CustomCSVLink;
